//
// RolesAssignmentController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataDefinitionController";
import "./RolesInspector";
import "../../models/dataDefinition/DataItem";

var RolesAssignmentController = createModule("BIRD::RolesAssignmentController", ["BIRD::BIRDModelController","BIRD::DataDefinitionController"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        replaceDataItem: [0,1,1,1],
        getRolesInspectors: [[1]],
        getAvailableDataSourceDataItems: [[1],1],
        addDataItem: [0,1,1],
        removeDataItem: [0,1,1],
        getOtherDataSourceDataItems: [[1],1],
        canRemoveDataItem: [2,1],
        canAddDataItem: [2,1],
        getAllAvailableDataSourceDataItems: [[1]],
        getRolesInspectorsWithDataItem: [[1],1],
    },
    ,
    ,
]);
export default RolesAssignmentController;
